import { makeAutoObservable } from "mobx";
import { apiObjUrl } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { MassEditFormData, MassEditRequestData } from "./types";

export const doMassEdit = (data: MassEditRequestData) =>
  rest.put(apiObjUrl("/entities/replacement-values"), data);
export class MassEditAttrStore {
  constructor() {
    makeAutoObservable(this);
  }

  loading = false;

  setLoading(flag: boolean) {
    this.loading = flag;
  }

  formData = undefined as MassEditFormData | undefined;

  setFormData(data: MassEditFormData | undefined) {
    this.formData = data;
  }
}

export const createMassEditAttrStore = () => new MassEditAttrStore();
